import React, { useCallback, useState } from 'react';
import useRootSelector from 'common/hooks/useRootSelector';
import { FormattedMessage } from 'react-intl';
import { Box, createStyles, makeStyles, Theme } from '@material-ui/core';
import isNumber from 'lodash/isNumber';

import { selectCheckInAllChildrenActionLoading } from 'modules/kid-zone/state/selectors';
import { selectUserSelectedClubId } from 'modules/authentication/state/selectors';
import { checkInAllChildren } from 'modules/kid-zone/state/actions';

import { useAppDispatch } from 'store/hooks';

import { ICheckInManuallySearch } from 'modules/kid-zone/interfaces';

import { DialogComponent } from 'common/components';
import { ChildCard } from 'modules/kid-zone/containers';
import { DaycareRedeemModal, GuardiansBlock } from 'modules/kid-zone/components';

import messages from 'modules/kid-zone/messages';
import { fromJS } from 'immutable';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    child: {
      '&:not(:last-child)': {
        marginBottom: theme.spacing(1),
      },
    },
  }),
);

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  member: ICheckInManuallySearch;
  onAddBirthday: (id: number) => void;
}

const CheckInAllModal = ({ isOpen, onClose, member, onAddBirthday }: IProps): JSX.Element => {
  const dispatch = useAppDispatch();

  const selectedClubId: string = useRootSelector(selectUserSelectedClubId);
  const isCheckInAllChildrenActionLoading: boolean = useRootSelector(
    selectCheckInAllChildrenActionLoading,
  );

  const [guardianId, setGuardianId] = useState<number | null>(null);

  const classes = useStyles();

  const handleOpenRedeemModal = (personId: number) => {
    setGuardianId(personId);
  };

  const handleCheckInAllChildren = useCallback(
    (serviceId: string) => {
      const childrenIds = member.children
        .filter(child => !child.checkedIn)
        .map(child => child.id.toString());

      if (isNumber(guardianId)) {
        dispatch(checkInAllChildren(selectedClubId, guardianId, serviceId, childrenIds));
      }
    },
    [dispatch, guardianId, member, selectedClubId],
  );

  return (
    <>
      {!guardianId ? (
        <DialogComponent
          isOpen={isOpen}
          onClose={onClose}
          size="xs"
          title={<FormattedMessage {...messages.checkInAllTitle} />}
          cancelBtn={false}
          submitBtn={false}
        >
          <Box mb={3}>
            {member.children.map(child => (
              <>
                {!child.checkedIn && <ChildCard child={fromJS(child)} className={classes.child} />}
              </>
            ))}
          </Box>

          <GuardiansBlock
            guardians={fromJS(member.guardians)}
            otherMembers={fromJS(member.other)}
            isSmallScreen
            isCheckInPanel
            isActionLoading={isCheckInAllChildrenActionLoading}
            onAddBirthday={onAddBirthday}
            onCheckInKid={handleOpenRedeemModal}
          />
        </DialogComponent>
      ) : (
        <DaycareRedeemModal
          isOpen={!!guardianId}
          onClose={() => setGuardianId(null)}
          guardianId={guardianId}
          isRedeemActionLoading={isCheckInAllChildrenActionLoading}
          onSubmit={handleCheckInAllChildren}
        />
      )}
    </>
  );
};

export default CheckInAllModal;
